import { IColor } from "./IColor";

export class Color {
  // カラーは結局16進表記かWebColorしか使わないと思うので、stringの値だけを持つ実装にしておく.
  constructor(public value: string) { }

  clone(): Color {
    return new Color(
      this.value
    );
  }

  static from(source: IColor): Color {
    if (!source) {
      return null;
    }
    return new Color(source.value);
  }

  static to(source: Color): IColor {
    if (!source) {
      return null;
    }
    return {
      value: source.value,
    };
  }
}
